/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unused-vars */
import HighchartsReact from 'highcharts-react-official';
import React, {
  useState, FC, useEffect, memo,
} from 'react';
import styled from 'styled-components';
import { maxWidth, retina } from 'Utils/utilsStyle';
import { ISeriesDataType } from 'Types/CommonTypes';
import classNames from 'classnames';
import { translateSkipAreas } from 'Utils/Constants';
import { useHighchartsModule } from 'Utils/hooks/useHighchartsModule';
import { Spin } from 'antd';

interface IDonutProps {
  data?: ISeriesDataType[];
  width?: number;
  height?: number;
  bgColor?: string;
  justifyContent?: boolean;
}
const defaultProps = {
  width: 430,
  height: 230,
  data: [
    { name: 'Customer engagement', y: 25 },
    { name: 'III Communication', y: 25 },
    { name: 'Intelligent Character Recognition', y: 25 },
    { name: 'Intelligent Tutoring System', y: 25 },
    { name: 'Natural language understanding', y: 25 },
  ],
  bgColor: 'rgba(0, 0, 0, 0)',
  justifyContent: false,
};

const StyledDiv = styled.div<{ bgColor: string }>`
  max-width: 100%;
  display: flex;
  justify-content: center;
  &.letAlignChart {
    justify-content: flex-start;
  }
  .highcharts-background {
    background-color: ${(props) => props.bgColor};
    max-width: 100%;
    .highcharts-container {
      max-width: 100%;
      svg {
        max-width: 100%;
      }
    }
  }
  .highcharts-title {
    left: 0 !important;
    width: 100%;
    text-align: center;
  }
  h4 {
    font-family: "Roboto Slab";
    font-weight: 400;
    font-size: 20px;
    @media all and (max-width: ${maxWidth}) , ${retina}  {
      font-size: 16px;
    }
  }
  text{
    color: rgb(0, 0, 0) !important;
    font-weight: normal !important;
    fill: rgb(0, 0, 0) !important;
  }
  tspan{
    stroke-width: 0.5px !important;
  }
`;
export const DonutChart: FC<IDonutProps> = function DonutChart({
  data, width, height, bgColor, justifyContent,
}) {
  const highcharts = useHighchartsModule();
  const colors = [
    '#2f7ed8',
    '#0d233a',
    '#8bbc21',
    '#910000',
    '#1aadce',
    '#492970',
    '#f28f43',
    '#77a1e5',
    '#c42525',
    '#a6c96a',
  ];
  const [chartOptions, setChartOptions] = useState({
    title: '',
    chart: {
      type: 'pie',
      height,
      width,
      backgroundColor: bgColor,
    },
    plotOptions: {
      pie: {
        dataLabels: {
          format: '{point.name}: {point.percentage:.1f} %',
        },
        innerSize: '50%',
      },
      series: {
        dataLabels: {
          enabled: true,
          format: '{name}',
        },
      },
    },
    series: [
      {
        name: 'concepts',
        data: data?.map(({ name, y, color }, index) => (
          { name, y, color: color || colors[index] })),
      }],
    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 400,
          },
        },
      ],
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
  });

  useEffect(() => {
    setChartOptions({
      ...chartOptions,
      series: [
        {
          name: 'score',
          data: data?.map(({ name, y, color }, index) => (
            { name, y, color: color || colors[index] })),
        }],
    });
  }, [data]);

  if (!highcharts) {
    return (
      <StyledDiv bgColor={bgColor || 'rgba(0, 0, 0, 0)'} className={classNames(`donut-chart-container ${translateSkipAreas}`, { letAlignChart: justifyContent })}>
        <Spin />
      </StyledDiv>
    );
  }

  return (
    <StyledDiv bgColor={bgColor || 'rgba(0, 0, 0, 0)'} className={classNames(`donut-chart-container ${translateSkipAreas}`, { letAlignChart: justifyContent })}>
      <HighchartsReact
        options={chartOptions}
        allowChartUpdate
        containerProps={{ className: 'highcharts-background' }}
        highcharts={highcharts}
      />
    </StyledDiv>
  );
};
DonutChart.defaultProps = defaultProps;
export default memo(DonutChart);
